module.exports = {
    fnCL: function (number) {
        var n = new Number(number);
        var def = { style: "currency", currency: "CLP" }
        return n.toLocaleString("es-CL", def);
    },
};
